import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import InstructionsPage from "./pages/InstructionsPage";
import ManageInventoryPage from "./pages/ManageInventoryPage";
import NotFoundPage from "./pages/NotFoundPage";
import { UserProvider } from "./context/UserContext";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { MODAL_TYPES } from "./constants/ModalTypes";
import { TABS } from "./constants/MainTabs";
import MaterialsPage, { MANAGE_MATERIAL_TABS } from "./pages/MaterialsPage";
import BaseLayout from "./layouts/BaseLayout";
import { DarkModeProvider } from "./context/DarkModeContext";
import About from "./pages/AboutPage";
import PrivacyPolicy from "./pages/PrivacyPolicyPage";
import Contact from "./pages/ContactPage";
import DonationPage from "./pages/DonationPage";

const AppRoutes: React.FC = () => (
    <BaseLayout>
        <Routes>
            <Route path="/" element={<HomePage/>}/>
            <Route path="/instructions" element={<InstructionsPage/>}/>
            {Object.values(MODAL_TYPES).map((modalType) => (
                <Route key={modalType} path={`/${modalType}`} element={<HomePage/>}/>
            ))}
            {TABS.map((tab, index) => (
                <Route
                    key={tab.endpoint}
                    path={`/${tab.endpoint}`}
                    element={<ManageInventoryPage activeTab={index}/>}
                />
            ))}
            {MANAGE_MATERIAL_TABS.map((tab, index) => (
                <Route
                    key={tab.endpoint}
                    path={`/materials/${tab.endpoint}`}
                    element={<MaterialsPage activeTab={index}/>}
                />
            ))}
            <Route path={"/about"} element={<About/>}/>
            <Route path={"/contact"} element={<Contact/>}/>
            <Route path={"/privacy"} element={<PrivacyPolicy/>}/>
            <Route path={"/donation"} element={<DonationPage/>}/>
            <Route path="*" element={<NotFoundPage/>}/>
        </Routes>
    </BaseLayout>
);

const theme = createTheme(); // Default theme

const RootApp: React.FC = () => (
    <React.StrictMode>
        <DarkModeProvider>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <UserProvider>
                    <Router>
                        <AppRoutes/>
                    </Router>
                </UserProvider>
            </ThemeProvider>
        </DarkModeProvider>
    </React.StrictMode>
);

export default RootApp;